import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace HotspotSessionValidation {
    export const Record = defineValidation(BaseRecordSchema);
}
